import { createSlice } from '@reduxjs/toolkit';
import {
  fetchDetailedUserAdmin,
  fetchUsersAdmin,
} from '../actions/admin.user.action';

const initialState = {
  users: {
    data: [],
    total: 0,
    isLoading: false,
    isNeedReloadData: false,
    next: null,
    previous: null,
  },
  detail: {
    data: null,
    isLoading: false,
    isNeedReloadData: false,
  },
};

export const adminUserReducer = createSlice({
  name: 'AdminUser',
  initialState,
  reducers: {
    reloadAdminUser: state => {
      state.users.isNeedReloadData = true;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUsersAdmin.pending, state => {
        state.users = {
          ...state.users,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchUsersAdmin.fulfilled, (state, action) => {
        if (action.payload) {
          const { data, total, next, previous } = action.payload;
          state.users = {
            ...state.users,
            data,
            total,
            isLoading: false,
            next,
            previous,
          };
        }
      })
      .addCase(fetchUsersAdmin.rejected, state => {
        state.users = { ...state.users, isLoading: false };
      })
      .addCase(fetchDetailedUserAdmin.pending, state => {
        state.detail = {
          ...state.detail,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchDetailedUserAdmin.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.detail = {
            ...state.detail,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchDetailedUserAdmin.rejected, state => {
        state.detail = { ...state.detail, isLoading: false };
      });
  },
});

export const { reloadAdminOrders, resetAdminOrdersData } =
  adminUserReducer.actions;

export default adminUserReducer.reducer;
